module.exports = __webpack_public_path__ + "static/photo-avatar-e12106b2ce502dd56bdf89022308e035.png";